import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-double-right",
  "use": "icon-chevron-double-right-usage",
  "viewBox": "0 0 18.001 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.001 12\" id=\"icon-chevron-double-right\">\r\n  <path d=\"M-1985-7235l4-4-4-4,2.062-2,5.938,6-5.938,6Zm-10,0,4-4-4-4,2.062-2,5.938,6-5.938,6Z\" transform=\"translate(1995.001 7245)\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol